const initMap = (el) => {
    // Find marker elements within map.
    const markers = el.querySelectorAll('.marker');
    
    // Get zoom data attr
    const zoom = parseInt(el.dataset.zoom);

    // Get lat and lng data attrs
    const lat = el.dataset.lat;
    const lng = el.dataset.lng;
    const latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    }

    // Create gerenic map
    const mapArgs = {
        zoom: zoom || 16,
        center: latLng,
        //mapId: 'a9ec3ce33fc10226',
        disableDefaultUI: true,
        styles:[{
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [{
                "saturation": 36
            }, {
                "color": "#212121"
            }, {
                "lightness": 40
            }]
        }, {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [{
                "visibility": "on"
            }, {
                "color": "#ffffff"
            }, {
                "lightness": 16
            }]
        }, {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#f2f2f2"
            }, {
                "lightness": 20
            }]
        }, {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#f2f2f2"
            }, {
                "lightness": 17
            }, {
                "weight": 1.2
            }]
        }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
                "color": "#f2f2ef"
            }, {
                "lightness": 20
            }]
        }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
                "color": "#f2f2f2"
            }, {
                "lightness": 21
            }]
        }, {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [{
                "visibility": "simplified"
            }]
        }, {
            "featureType": "poi.business",
            "elementType": "all",
            "stylers": [{
                "color": "#626262"
            }]
        }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{
                "color": "#c7c7c7"
            }, {
                "lightness": 21
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#ffffff"
            }, {
                "lightness": 17
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#ffffff"
            }, {
                "lightness": 29
            }, {
                "weight": 0.2
            }]
        }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
                "color": "#ffffff"
            }, {
                "lightness": 18
            }]
        }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
                "color": "#ffffff"
            }, {
                "lightness": 16
            }]
        }, {
            "featureType": "road.local",
            "elementType": "labels",
            "stylers": [{
                "visibility": "simplified"
            }]
        }, {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [{
                "color": "#f2f2f2"
            }, {
                "lightness": 19
            }]
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
                "color": "#e7b131"
            }, {
                "lightness": 17
            }]
        }]
    };

    const map = new google.maps.Map(el, mapArgs);

    // Check if markers exist, assuming they will want this addded in future
    if(markers && markers.length !== 0) {
        // Add markers
        map.markers = [];

        markers.forEach((marker) => {
            initMarker(marker, map);
        });

        //Center map based on markers.
        centerMap(map);
    }

    // Return map instance.
    return map;
}

// Init markers if they exist
const initMarker = (marker, map) => {
    // Get position from marker.
    const lat = marker.dataset.lat;
    const lng = marker.dataset.lng;

    const latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create icon object. theme.url set in enqueue.php with wp_localize
    var icon = {
        url: `${theme.url}/includes/svgs/marker.svg`,
        scaledSize: new google.maps.Size(40, 40),
        origin: new google.maps.Point(0,0),
        anchor: new google.maps.Point(20, 40)
    };

    // Create marker instance.
    const mapMarker = new google.maps.Marker({
        position : latLng,
        map: map,
        icon: icon
    });

    // Append to reference for later use.
    map.markers.push(mapMarker);

   
}

const centerMap = (map) => {
    // Create map boundaries from all map markers.
    const bounds = new google.maps.LatLngBounds();

    map.markers.forEach(function(marker){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    map.setCenter(bounds.getCenter());
}

window.addEventListener('DOMContentLoaded', () => {
    let maps = document.querySelectorAll('.js-map');

    if(maps && maps.length !== 0) {
        maps.forEach((map) => {
            initMap(map);
        })
    }
});
